/* eslint-disable no-unused-expressions */
/******************************************************************************
 * PointerControl Class
 * version: 1.0.7, release: 28.03.2023
 * author: albert lang, albert.lang@jumptoday.group
 * ----------------------------------------------------------------------------
 * description:
 * this will replace the old DragControl api (lib.r2/utils/DragControl.js)
 * dependencies: none
 * 
 * todos:
 * 
 * enabled property
 * 
 * css: body {
 * 		touch-action: none;		//to use pointer-events for touch-displays
 * }
 * 
******************************************************************************/


//============================================================================= PointerControl Class
export default class PointerControl {
	enabled = true

	static defaultProps = {
		selfOnly	: false,	//use events only if native target clicked
		fitToPixel 	: true,		//round pointer position to integer
		dragLimit	: 0,		//limit before start draging
		// downDelay	: 300,		//ignore drag event if touched time is smaller

		includes	: null,		//included events targets
		excludes	: null,		//excluded events targets

		onDown		: null,
		// onDownDelay	: null,		//???
		onUp		: null,
		onClick		: null,
		onDragStart	: null,
		onDrag		: null,
		onDragStop	: null,

		// type		: null, 	//down event type: touch | mouse | pointer
	}


	set target(target_){
		if (this._target){		//remove existing target
			this.clearEvents()
			this._target.removeEventListener('mousedown', this.downBind);
			this._target.removeEventListener('touchstart', this.downBind);
		}

		this._target = target_;
		if (!target_) return

		this._target.addEventListener('mousedown', this.downBind);	//-> onPointerDown
		this._target.addEventListener('touchstart', this.downBind);	//-> onPointerDown
	}

	
	get target(){
		return this._target
	}


	constructor(target_, props){
		this.init(props);
		if (target_) this.target = target_
	}


	init(props){
		// console.log('---init PointerControl')

		this.props = {...PointerControl.defaultProps, ...props};
		// this.props = props;

		this.downBind = this.onDown.bind(this);
		this.moveBind = this.onMove.bind(this);
		this.upBind = this.onUp.bind(this);

		this.scale	= this.props.scale
		this.pos	= {x:0, y:0};		//current pointer position
		this.move	= {x:0, y:0};		//moved frame diff
		this.start	= {x:0, y:0};	//pointer start position
		this.drag	= {x:0, y:0};		//drag width and height while moving
		this.isDown	= false;
		this.isTouch = false;		//ignore mouse events if true
		this.isDragging = false;
		// this.scale = 1;
	}


	onDown(e){
		if (!this.enabled || this.isDown || !this._target) return		//already down

		// e.preventDefault();

		let p = this.props;
		if (p.selfOnly && e.target !== this._target) return;
		if (p.includes && !p.includes.includes(e.target.className) && !p.includes.includes(e.target.id)) return;
		if (p.excludes && (p.excludes.includes(e.target.className) || p.excludes.includes(e.target.id))) return;

		e.stopPropagation();

		this.isDown = true;
		this.isDragging = false;

		// this.targetRect = this._target.getBoundingClientRect();
		// let client = this._target.parentNode
		let client = this._target
		this.targetRect = client.getBoundingClientRect();
		// this.scale = this.scale || this.targetRect.width / client.clientWidth || 1;		//???
		this.scale = this.props.scale || this.targetRect.width / client.clientWidth || 1;

		this.setEvents(e);

		this.start.x = this.pos.x;
		this.start.y = this.pos.y;
		this.drag.x = this.drag.y = 0;

		p.onDown?.(this, e);
	}


	onMove(e){
		if (!this.enabled || !this.isDown || !this._target) return;

		// e.preventDefault();
		e.stopPropagation();

		let px, py, p = this.props;

		if (e.touches){
			let t = e.touches[0];
			px = (t.clientX - this.targetRect.x) / this.scale;
			py = (t.clientY - this.targetRect.y) / this.scale;

		}else{
			px = (e.clientX - this.targetRect.x) / this.scale;
			py = (e.clientY - this.targetRect.y) / this.scale;
		}
		// px = (e.clientX - this.targetRect.x) / this.scale;
		// py = (e.clientY - this.targetRect.y) / this.scale;

		if (p.fitToPixel){
			px = Math.round(px);
			py = Math.round(py);
		}

		this.drag.x = px - this.start.x;
		this.drag.y = py - this.start.y;

		if (!this.isDragging){
			if (Math.abs(this.drag.x) < p.dragLimit && Math.abs(this.drag.y) < p.dragLimit) return;

			// clearTimeout(this._downTimeout);

			this.start.x = this.pos.x = px;
			this.start.y = this.pos.y = py;
			this.drag.x = this.drag.y = 0;

			this.onDragStart();
		}

		this.move.x = px - this.pos.x;
		this.move.y = py - this.pos.y;

		this.pos.x = px;
		this.pos.y = py;

		if (this.isDragging) this.props.onDrag?.(this, e);
	}


	onDragStart(){
		this.isDragging = true;
		this.props.onDragStart?.(this);
	}


	onUp(e){
		if (!this.isDown) return

		// e.preventDefault();
		e.stopPropagation();

		if (this.isDragging) this.onDragStop(e);
		else this.onClick(e);

		this.clearEvents();

		this.props.onUp?.(this, e);
	}


	onDragStop(e){
		if (!this.enabled) return
		this.isDragging = false;
		this.props.onDragStop?.(this, e);
	}


	onClick(e){
		if (!this.enabled) return
		this.props.onClick?.(this, e);
	}

	
	setEvents(e){
		// document.addEventListener('pointermove', this.moveBind);	//-> onPointerDown
		// document.addEventListener('pointerup', this.upBind);	//-> onPointerDown

		if (e.type === 'touchstart'){
			this.isTouch = true;
			this._target.removeEventListener('mousedown', this.downBind);	//no mouse events

			document.addEventListener('touchmove', this.moveBind);
			document.addEventListener('touchcancel', this.upBind);
			document.addEventListener('touchend', this.upBind);

			this.pos.x = (e.touches[0].clientX - this.targetRect.x) / this.scale;
			this.pos.y = (e.touches[0].clientY - this.targetRect.y) / this.scale;

		}else{
			document.addEventListener('mousemove', this.moveBind);	//-> onPointerMove
			document.addEventListener('mouseup', this.upBind);		//-> onPointerUp

			this.pos.x = (e.clientX - this.targetRect.x) / this.scale;	//supports scaled dom elements
			this.pos.y = (e.clientY - this.targetRect.y) / this.scale;
		}
		// this.pos.x = (e.clientX - this.targetRect.x) / this.scale;	//supports scaled dom elements
		// this.pos.y = (e.clientY - this.targetRect.y) / this.scale;

		if (this.props.fitToPixel){
			this.pos.x = Math.round(this.pos.x);
			this.pos.y = Math.round(this.pos.y);
		}
	}


	clearEvents(){
		if (!this.isDown) return;
	
		// document.removeEventListener('pointermove', this.moveBind);	//-> onPointerDown
		// document.removeEventListener('pointerup', this.upBind);	//-> onPointerDown

		if (this.isTouch){
			document.removeEventListener('touchmove', this.moveBind);
			document.removeEventListener('touchcancel', this.upBind);
			document.removeEventListener('touchend', this.upBind);
		}else{
			document.removeEventListener('mousemove', this.moveBind);
			document.removeEventListener('mouseup', this.upBind);
		}

		this.isDragging = false;
		this.isDown = false;
		// this.isTouch = false;
	}
}
